<template>
  <div class="product">
    <div class="bannerTemp">
      <bannerTemp :data="bannerData"></bannerTemp>
    </div>
    <div class="mobile-bannerTemp">
      <bannerTemp :data="bannerData"></bannerTemp>
    </div>
    <div class="module">
      <div class="right">
        <img src="../assets/images/product/product_img3.png" alt />
        <div>
          <div class="title" v-jump="'/product/product3'">
            ZTMap3D
            <span>/三维融合渲染平台</span>
          </div>
          <div
            class="p"
          >臻图ZTMap系列轻量化三维融合渲染平台，实现了宏观二三维GIS地理信息、微观建筑物室内BIM模型的统一集成渲染和无缝漫游体验。创新的轻量化设计理念和开发架构，解决了从宏观到微观海量三维模型数据的加载和渲染效率难题，实现了空间数据的渐进加载和极速渲染功能，提供了良好的用户体验。该产品简便易用的交互式二次开发接口和可视化工具，极大缩短了三维可视化应用开发的周期、降低了可视化应用开发的门槛和成本。</div>
          <div class="btn" v-jump="'/product/product3'">了解更多</div>
        </div>
      </div>
      <div class="left">
        <img src="../assets/images/product/product_img4.png" alt />
        <div>
          <div class="title" v-jump="'/product/product4'">
            ZTMapVR
            <span>/VR全景三维可视化平台</span>
          </div>
          <div
            class="p"
          >臻图ZTMapVR平台是一个基于实景照片实现快速三维建模的软件产品，其主要目的是为了实现智能化快速三维建模。基于“ZTMapVR”平台可以快速实现大部分场景下的高保真建模，并提供快速场景发布能力。提供强大的沉浸式渲染和交互开发能力，并可结合GIS、BIM等空间可视化技术和产品，实现空间分析能力。可以广泛应用于GIS、BIM、VR/AR、物联网、互联网等智慧城市各领域。</div>
          <div class="btn" v-jump="'/product/product4'">了解更多</div>
        </div>
      </div>
      <div class="right">
        <img src="../assets/images/product/product_img1.png" alt />
        <div>
          <div class="title" v-jump="'/product/product1'">
            ZTMapGIS
            <span>/二三维GIS地理信息平台</span>
          </div>
          <div
            class="p"
          >ZTMapGIS系列二三维GIS地理信息可视化平台软件，是臻图信息自主研发的一款企业级空间GIS地理信息可视化软件。ZTMapGIS是一款轻量级空间数据可视化平台软件，提供B/S结构的WEBGIS开发框架、Android、IOS等移动平台开发框架；基于该平台可以轻松实现功能丰富的二维地图、三维地图一体化集成发布；实现在线、离线一体化应用解决方案。</div>
          <div class="btn" v-jump="'/product/product1'">了解更多</div>
        </div>
      </div>
      <div class="left">
        <img src="../assets/images/product/product_img2.png" alt />
        <div>
          <div class="title" v-jump="'/product/product2'">
            ZTMapEasy
            <span>/2.5D-GIS平台</span>
          </div>
          <div
            class="p"
          >臻图ZTMapEasy是专为2.5D（亦称假三维）地图渲染和应用开发研发的轻量级GIS产品。该产品提供了2.5D地图渲染及数据切片处理能力，同时实现了与传统二维GIS地图的无缝整合能力。并提供丰富的常用开发接口，简化基于2.5D地图的应用开发难度和流程。</div>
          <div class="btn" v-jump="'/product/product2'">了解更多</div>
        </div>
      </div>
      <div class="right">
        <img src="../assets/images/product/product_img5.png" alt />
        <div>
          <div class="title" v-jump="'/product/product5'">
            ZTMapIndoor
            <span>/室内地图可视化平台</span>
          </div>
          <div
            class="p"
          >臻图室内GIS地图平台是应用于室内场景的二三维矢量地图可视化渲染平台，该产品实现了室内地图数据管理维护、室内地图前端展示渲染、应用开发调用一体化的完整功能体系。该产品以好看、好用、流畅作为开发设计的原则和目标。</div>
          <div class="btn" v-jump="'/product/product5'">了解更多</div>
        </div>
      </div>
    </div>
    <div class="mobile-content">
      <div class="content-part">
        <div class="content-title" v-jump="'/product/product3'">
          ZTMap3D
              <span>/三维融合渲染平台</span>
        </div>
        <div class="main-content">
          <div class="main-left">
            <p>
              臻图ZTMap系列轻量化三维融合渲染平台，实现了宏观二三维GIS地理信息、微观建筑物室内BIM模型的统一集成渲染和无缝漫游体验。创新的轻量化设计理念和开发架构，解决了从宏观到微观海量三维模型数据的加载和渲染效率难题，实现了空间数据的渐进加载和极速渲染功能，提供了良好的用户体验。该产品简便易用的交互式二次开发接口和可视化工具，极大缩短了三维可视化应用开发的周期、降低了可视化应用开发的门槛和成本。
            </p>
            <div class="see-more" v-jump="'/product/product3'">了解更多  >></div>
          </div>
          <img src="../assets/images/index/banner_img3.png" alt="">
        </div>
      </div>
      <div class="content-part" style="background-color: rgba(0, 0, 0, 0.03);;">
        <div class="content-title" v-jump="'/product/product4'">
          ZTMapVR
            <span>/VR全景三维可视化平台</span>
        </div>
        <div class="main-content">
          <img src="../assets/images/index/banner_img4.png" alt="">
          <div class="main-left">
            <p>
              臻图ZTMapVR平台是一个基于实景照片实现快速三维建模的软件产品，其主要目的是为了实现智能化快速三维建模。基于“ZTMapVR”平台可以快速实现大部分场景下的高保真建模，并提供快速场景发布能力。提供强大的沉浸式渲染和交互开发能力，并可结合GIS、BIM等空间可视化技术和产品，实现空间分析能力。可以广泛应用于GIS、BIM、VR/AR、物联网、互联网等智慧城市各领域。
            </p>
            <div class="see-more" v-jump="'/product/product4'">了解更多  >></div>
          </div>
        </div>
      </div>
      <div class="content-part">
        <div class="content-title" v-jump="'/product/product1'">
          ZTMapGIS
            <span>/二三维GIS地理信息平台</span>
        </div>
        <div class="main-content">
          <div class="main-left">
            <p>
              ZTMapGIS系列二三维GIS地理信息可视化平台软件，是臻图信息自主研发的一款企业级空间GIS地理信息可视化软件。ZTMapGIS是一款轻量级空间数据可视化平台软件，提供B/S结构的WEBGIS开发框架、Android、IOS等移动平台开发框架；基于该平台可以轻松实现功能丰富的二维地图、三维地图一体化集成发布；实现在线、离线一体化应用解决方案。
            </p>
            <div class="see-more" v-jump="'/product/product1'">了解更多  >></div>
          </div>
          <img src="../assets/images/index/banner_img1.png" alt="">
        </div>
      </div>
      <div class="content-part" style="background-color: rgba(0, 0, 0, 0.03);;">
        <div class="content-title" v-jump="'/product/product2'">
          ZTMapEasy
            <span>/2.5D-GIS平台</span>
        </div>
        <div class="main-content">
          <img src="../assets/images/index/banner_img2.png" alt="">
          <div class="main-left">
            <p>
              臻图ZTMapEasy是专为2.5D（亦称假三维）地图渲染和应用开发研发的轻量级GIS产品。该产品提供了2.5D地图渲染及数据切片处理能力，同时实现了与传统二维GIS地图的无缝整合能力。并提供丰富的常用开发接口，简化基于2.5D地图的应用开发难度和流程。
            </p>
            <div class="see-more" v-jump="'/product/product2'">了解更多  >></div>
          </div>
          
        </div>
      </div>
      <div class="content-part">
        <div class="content-title" v-jump="'/product/product5'">
          ZTMapIndoor
            <span>/室内地图可视化平台</span>
        </div>
        <div class="main-content">
          <div class="main-left">
            <p>
              臻图室内GIS地图平台是应用于室内场景的二三维矢量地图可视化渲染平台，该产品实现了室内地图数据管理维护、室内地图前端展示渲染、应用开发调用一体化的完整功能体系。该产品以好看、好用、流畅作为开发设计的原则和目标。
            </p>
            <div class="see-more" v-jump="'/product/product5'">了解更多  >></div>
          </div>
          <img src="../assets/images/index/banner_img5.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Product',
  metaInfo: {
    title: '产品中心_智慧城市空间信息可视化产品-上海臻图信息技术有限公司',
    meta: [
      {
        name: 'keywords',
        content:
          '二三维GIS平台,2.5D-GIS平台,三维融合渲染平台,VR全景三维可视化平台,室内GIS地图平台,AR可视化平台'
      },
      {
        name: 'description',
        content:
          '四个专业技术领域：GIS、BIM、VR、AR；6个核心产品：二三维GIS平台、2.5D-GIS平台、三维融合渲染平台、VR全景三维可视化平台、室内GIS地图平台、AR可视化平台。'
      }
    ]
  },
  data () {
    return {
      bannerData: {
        title: '产品中心',
        p:
          '四个专业技术领域：GIS、BIM、VR、AR。6个核心产品：二三维GIS平台、2.5D-GIS平台、三维融合渲染平台、VR全景三维可视化平台、室内GIS地图平台、AR可视化平台。'
      }
    }
  },
  mounted: function () {}
}
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../assets/images/product/banner.jpg");
}
.product {
  > .module {
    & > div:nth-child(1) img {
      width: 700px;
    }
    & > div:nth-child(2) img {
      width: 547px;
    }
    & > div:nth-child(3) img {
      width: 646px;
    }
    & > div:nth-child(4) img {
      width: 559px;
    }
    & > div:nth-child(5) img {
      width: 700px;
    }
    > div {
      overflow: hidden;
      margin-top: 117px;
      position: relative;
      &:last-child {
        margin-bottom: 150px;
      }
      &.left {
        img {
          position: absolute;
          left: 0;
        }
        text-align: right;
      }
      &.right {
        img {
          position: absolute;
          right: 0;
        }
        text-align: left;
      }
      > div {
        width: 480px;
        text-align: left;
        display: inline-block;
        > .title {
          font-size: 38px;
          cursor: pointer;
          color: rgba(58, 58, 58, 1);
          span {
            font-size: 19px;
          }
        }
        > .p {
          font-size: 16px;
          line-height: 32px;
          color: rgba(124, 124, 124, 1);
          margin-top: 40px;
        }
        > .btn {
          width: 156px;
          height: 48px;
          border-radius: 24px;
          border: 1px solid rgba(124, 124, 124, 1);
          display: inline-block;
          font-size: 18px;
          color: rgba(75, 75, 75, 1);
          line-height: 48px;
          margin-top: 30px;
          margin-bottom: 258px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
}
.mobile-bannerTemp {
  background-image: url("../assets/images/product/banner.jpg");
  background-position: 60%;
  background-size: cover;
  height: 28rem;
  display: none;
}
.product {
  > .mobile-content {
    width: 100%;
    display: none;
    flex-direction: column;
    .content-part {
      box-sizing: border-box;
      padding: 2rem;
      .content-title {
        width: 100%;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        >span {
          margin-left: 1rem;
          font-size: 1.4rem;
          font-weight: 350;
          line-height: 2rem;
        }
      }
      .main-content {
        width: 100%;
        height: 12.3rem;
        display: flex;
        align-items: flex-end;
        font-family: 'Normal';
        margin-top: 1.5rem;
        justify-content: space-between;
        >.main-left {
          width: 17rem;
          >p {
            height: 10rem;
            word-break: break-all;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            font-size: 1rem;
            font-weight: 350;
            line-height: 2rem;
            color: #3D3D3D;
          }
          >div.see-more {
            color: #3C80E8;
            font-size: 1rem;
            font-weight: 350;
            line-height: 2rem;
            cursor: pointer;
          }
        }
        >img {
          width: 15rem;
          height: 12.3rem;
        }
      }
    }
    
  }
}
@media (max-width: 1024px) {
  .bannerTemp {
    display: none !important;
  }
  .product {
    > .module {
      display: none !important;
    }
    > .mobile-content {
      display: flex !important;
    }
  }
  .mobile-bannerTemp { 
    display: flex !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product.vue